/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/**
 * Rounds a finite number to the requested number of significant digits.
 *
 * Formatting trailing zeroes is deliberately left to the presentation layer.
 */
export function roundToSignificantDigits(value: number, significantDigits: number): number {
    if (!Number.isInteger(significantDigits) || significantDigits < 1) {
        throw new RangeError('significantDigits must be a positive integer.');
    }

    if (!Number.isFinite(value) || value === 0) {
        return value;
    }

    const magnitude = Math.floor(Math.log10(Math.abs(value)));
    const factor = 10 ** (magnitude - significantDigits + 1);

    return Math.sign(value) * Math.round(Math.abs(value) / factor) * factor;
}
